import Axios from 'axios';
import dayjs from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import NotData from '../../components/NotData';
import { Toast } from '../../common/message';
import UserPointExp from '../../common/UserPointExp';

const Delivery = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  // 숫자 천자리 콤마
  function NumberConvert(num)
  {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }

  const [books, setBooks] = useState([]);
  const columns = [
    'No', '담당', '배송', '고객명', '연락처', '상세주소', '성별', '주문내역 및 메모'
  ];

  const firstCursor = useRef(null);

  const [itemIdx, setItemIdx] = useState(0);

  const [totalDelivery, setTotalDelivery] = useState(0);
  const [searchDate, setSearchDate] = useState('');

  const [deliveryNo, setDeliveryNo] = useState(0);

  const [searchText, setSearchText] = useState('');
  const [userName, setUserName] = useState('');
  const [deliveryType, setDeliveryType] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const [userStore, setUserStore] = useState('');
  const [userGender, setUserGender] = useState('');
  const [userAddress, setUserAddress] = useState('');
  const [deliveryPrice, setDeliveryPrice] = useState('');
  const [totalPrice, setTotalPrice] = useState('');
  const [deliveryMemo, setDeliveryMemo] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  
  // 토탈 처리 건 수 불러오기
  const TotalDelivery = async ()=>{
    await Axios.get(`/api/delivery/totaldelivery`) 
    .then((res)=>{
      setTotalDelivery(res.data[0].total);
    })
  }

  // 검색 버튼
  const userSearchHandler = async ()=>{
    if(!searchText) return alert('검색어를 입력해 주세요');

    await Axios.get(`/api/delivery/deliverylist_search`, {
      params: { searchText }
    })
    .then((res) => {
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  }

  // 리스트 불러오기
  const deliveryListLoade = async () => {
    await Axios.get(`/api/delivery/deliverylist`, {
      params: { Date: toDay.date }
    })
    .then((res) => {
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  };

  // 날짜 변경시
  const ChangedDate = async (e)=>{
    await Axios.get(`/api/delivery/deliverylist`, {
      params: { Date: e.target.value }
    })
    .then((res)=>{
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    })
  };
  
  const basicStore = window.sessionStorage.getItem('basicStore');

  // 날짜 및 바로 실행될 부분
  useEffect(()=>{
    document.title = '택배/퀵';

    firstCursor.current.focus();

    setSearchDate(toDay.date)

    setUserStore(basicStore);
    setDeliveryType('택배');
  }, [])

  useMemo(()=>{
    TotalDelivery();
    deliveryListLoade();
  }, []);

  // 택비 퀵 등록
  const btnDeliveryAdd = async ()=>{
    if(!userName) return alert('고객님 성함을 입력해주세요');
    if(!deliveryType) return alert(`${userName}님의 배송 분류를 선택해 주세요`);
    if(!userPhone) return alert(`${userName}님의 연락처를 입력해 주세요`);
    if(!Number(userPhone)) return alert(`연락처는 숫자만 입력해 주세요`);
    if(!userStore) return alert(`${userName}님의 담당 매장을 선택해 주세요`);
    if(!userGender) return alert(`${userName}님의 성별을 선택해 주세요`);
    if(!userAddress) return alert(`${userName}님의 배송 주소지를 입력해주세요`);
    if(!deliveryPrice) return alert(`${userName}님이 지불하신 배송비를 입력하세요`);
    if(!Number(deliveryPrice)) return alert(`배송비는 숫자만 입력하세요`);
    if(!totalPrice) return alert(`배송비를 제외한 ${userName}님이 결제하신 총 금액을 입력하세요`);
    if(!Number(totalPrice)) return alert(`총 금액은 숫자만 입력하세요`);
    if(!deliveryMemo) return alert(`${userName}님이 택배/퀵으로 주문하신 제품들 상세내역을 입력해주세요`);

    if(!window.confirm(`${userName}님을 등록하시겠습니까?`)) return;

    await Axios.post(`/api/delivery/deliveryadd`, {
      Name: userName, DeliveryType: deliveryType, Phone: userPhone, Store: userStore,
      Gender: userGender, Address: userAddress, DeliveryPrice: deliveryPrice,
      TotalPrice: totalPrice, Item: deliveryMemo, Date: toDay.time
    })
    .then((res)=>{

      // 처리시 복사 데이터에 즉시 반영
      setBooks(()=>{
        const addData = {
          store: userStore, delivery: deliveryType, name: userName,
          phone: userPhone, address: userAddress, gender: userGender,
          item: deliveryMemo, price: deliveryPrice, total: totalPrice,
          date: toDay.time
        };
        const copyTB = [...books, addData];
        return copyTB;
      });

      TotalDelivery();

      reset();
      Toast.fire({ icon: "success", text: `${userName}님 등록 성공` });

      // 포인트 및 기여도 지급
      UserPointExp('택배퀵', `${userName} 택배/퀵 등록`, 5, 5);
    })
  }

  // 택배 퀵 수정
  const btnDeliveryUpdate = async ()=>{

    if(!deliveryNo) return alert('수정할 고객을 선택해주세요');
    if(!window.confirm(`${userName}님의 수정 사항들을 반영하시겠습니까?`)) return;

    await Axios.put(`/api/delivery/deliveryupdate`, {
      Name: userName, DeliveryType: deliveryType, Phone: userPhone, Store: userStore,
      Gender: userGender, Address: userAddress, DeliveryPrice: deliveryPrice,
      TotalPrice: totalPrice, Item: deliveryMemo, Date: toDay.time, No: deliveryNo
    })
    .then((res)=>{

    // 수정된 값으로 교체
    setBooks(()=>{
      const copy = [...books];
      copy[itemIdx].store = userStore;
      copy[itemIdx].delivery = deliveryType;
      copy[itemIdx].name = userName;
      copy[itemIdx].phone = userPhone;
      copy[itemIdx].address = userAddress;
      copy[itemIdx].gender = userGender;
      copy[itemIdx].item = deliveryMemo;
      copy[itemIdx].price = deliveryPrice;
      copy[itemIdx].total = totalPrice;
      copy[itemIdx].update_date = toDay.time;
      return copy;
    });

      reset();
      Toast.fire({ icon: "success", text: `${userName}님 수정 성공` });

      // 포인트 및 기여도 지급
      UserPointExp('택배퀵', `${userName} 택배/퀵 수정`, 2, 2);
    })
  }

  // 택배 퀵 삭제
  const btnDeliveryDelete = async ()=>{

    if(!deliveryNo) return alert('삭제할 고객을 선택해주세요');
    if(!window.confirm(`복구는 불가능합니다, ${userName}님을 삭제하시겠습니까?`)) return;

    await Axios.delete(`/api/delivery/deliverydelete/` + deliveryNo)
    .then((res)=>{
       // 데이터 테이블에 안 보이게 처리
      setBooks(books.filter(item => item.no !== deliveryNo));
      TotalDelivery();
      
      reset();
      Toast.fire({ icon: "success", text: `${userName}님 삭제 성공` });

      // 포인트 및 기여도 지급
      UserPointExp('택배퀵', `${userName} 택배/퀵 삭제`, 1, 1);
    });
  }

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  // 리셋 함수
  const reset = ()=>{
    setSearchText('');
    setUserStore('선택');
    setUserGender('선택');
    setUserName('');
    setDeliveryType('선택');
    setUserPhone('');
    setUserAddress('');
    setDeliveryPrice('');
    setTotalPrice('');
    setDeliveryMemo('');
    setDeliveryDate('');

    setSelectedRow(-1);
  }

  return (
    <div className='grid grid-cols-1 md:flex md:justify-between p-3 text-sm md:h-[calc(100vh-4rem)] gap-1'>
      
      {/* 메인 */}
      <div className='relative border-[1px] border-gray-500 w-full md:w-3/4 md:h-full h-[60vh] overflow-y-auto'>
        <table id='testTable' className='w-full'>
          <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10'>
            <tr className='border-b-[1px] border-gray-500'>
              {columns.map((column) => (
                <th className='p-3 whitespace-nowrap' key={column}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody className='text-center'>
            {
              books.length ?
              books.map((book, idx) => (
                <tr className=
                {`
                  duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                  ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                `} 
                key={idx} onClick={(e)=>{
                  setSelectedRow(idx);
                  setItemIdx(idx);
                  setDeliveryNo(book.no)
                  setUserStore(book.store);
                  setDeliveryType(book.delivery);
                  setUserName(book.name);
                  setUserPhone(book.phone);
                  setUserAddress(book.address);
                  setUserGender(book.gender);
                  setDeliveryMemo(book.item);
                  setDeliveryPrice(book.price);
                  setTotalPrice(book.total);
                  setDeliveryDate(book.date);

                  // setModal(true);
                }}>
                  <td className='p-2.5'>{idx + 1}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.store}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.delivery}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.phone}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500 max-w-[300px]'>{`${book.address.length > 15 ? book.address.substr(0, 15) + '...' : book.address}`}</td>
                  <td className='p-2.5 border-x-[1px] border-gray-500'>{book.gender}</td>
                  <td className='p-2.5 max-w-[300px]'>{`${book.item.length > 15 ? book.item.substr(0, 15) + '...' : book.item}`}</td>
                </tr>
              ))
              :
              <tr className='relative'>
                <td className='absolute w-full top-[30vh] left-auto'>
                  <NotData/>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      {/* 사이드 */}
      <div className='md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500'>
        <div className='bg-[#0067BD] py-2 text-center'>
          <p className='text-left pl-3'>
            ※ 택배 및 퀵 처리 내역
          </p>
        </div>

        <div className='p-3 flex flex-col gap-2'>

          {/* 택배 / 퀵 처리 건 수*/}
          <div className='flex flex-col justify-center items-center h-12 gap-1 bg-[#2E2E2E] rounded-md p-3'>
            <p className='text-sm'>택배 / 퀵 처리 : {NumberConvert(totalDelivery)} 건</p>
          </div>

          {/* 이름, 연락처 검색 */}
          <form className='w-full flex gap-2' autoComplete='off' onSubmit={(e)=>e.preventDefault()}>
            <input ref={firstCursor} id='searchInput' className='bg-[#2E2E2E] h-12 w-full p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='search' placeholder='이름 or 연락처' value={searchText} onChange={(e)=>setSearchText(e.target.value)}/>
            <input className='bg-blue-600 px-3 py-2 h-12 rounded-sm w-[30%] cursor-pointer' type='submit' value='검색' onClick={()=>userSearchHandler()}/>
          </form>  

          {/* 날짜 조회 */}
          <div className='w-full'>
            <p>날짜 조회</p>
            <input id='dateInput' type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={searchDate} onChange={(e)=>{
              setSearchDate(e.target.value);
              ChangedDate(e);
            }} />
          </div>

          {/* 언더라인 */}
          <div className='border-b-[1px] border-gray-400 py-1'></div>

          {/* 매장 선택 및 성별 */}
          <div className='grid grid-cols-1 lg:grid-cols-2 justify-center items-center gap-2'>
            <div className='w-full'>
              <p>매장 선택</p>
              <select className='w-full h-12 bg-[#2E2E2E] mt-1 p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' value={userStore} onChange={(e)=>setUserStore(e.target.value)}>
                <option>선택</option>
                <option>탄방점</option>
                <option>둔산점</option>
                <option>자양점</option>
                <option>충대점</option>
              </select>
            </div>
            <div className='w-full'>
              <p>배송</p>
              <select className='w-full h-12 bg-[#2E2E2E] mt-1 p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' value={deliveryType} onChange={(e)=>setDeliveryType(e.target.value)} >
                <option>선택</option>
                <option>택배</option>
                <option>퀵</option>
                <option>무료</option>
              </select>
            </div>
          </div>

          {/* 이름 및 택배 분류 */}
          <div className='grid grid-cols-1 lg:grid-cols-2 justify-center items-center gap-2'>
            <div className='w-full'>
              <p>성함</p>
              <input className='bg-[#2E2E2E] h-12 w-full mt-1 p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='search' placeholder='이름' value={userName} onChange={(e)=>setUserName(e.target.value)} />
            </div>
            <div className='w-full'>
              <p>성별</p>
              <select className='w-full h-12 bg-[#2E2E2E] mt-1 p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' value={userGender} onChange={(e)=>setUserGender(e.target.value)} >
                <option>선택</option>
                <option>남성</option>
                <option>여성</option>
              </select>
            </div>
          </div>

          {/* 이름, 연락처 검색 */}
          <div className='w-full flex flex-col gap-2'>
            <p>연락처</p>
            <input id='searchInput' className='bg-[#2E2E2E] h-12 w-full p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='search' placeholder='연락처' value={userPhone} onChange={(e)=>setUserPhone(e.target.value)}/>
          </div>  

          <div className='flex flex-col gap-2 w-full'>
            <div className='flex justify-between'>
              <p className=''>주소</p>
              <button className='px-2 text-yellow-400' onClick={()=>alert('텍스트박스 우측 하단을 드래그시 창을 늘리거나 축소 할 수 있습니다.')}>
                펼치기
              </button>
            </div>
            <div className='flex flex-col justify-center items-center'>
              <textarea className='bg-[#2E2E2E] rounded-md w-full h-[70px] border-[1px] outline-none border-gray-300 ml-5 mr-5 p-3' type='text' placeholder='주소를 입력해 주세요' value={userAddress} onChange={(e)=>setUserAddress(e.target.value)} />
            </div>
          </div>

          {/* 이름 및 택배 분류 */}
          <div className='grid grid-cols-1 lg:grid-cols-2 justify-center items-center gap-2'>
            <div className='w-full'>
              <p>배송비</p>
              <input className='bg-[#2E2E2E] h-12 w-full mt-1 p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='text' placeholder='배송비' value={deliveryPrice} onChange={(e)=>setDeliveryPrice(e.target.value)} />
            </div>
            <div className='w-full'>
              <p>결제 금액</p>
              <input className='bg-[#2E2E2E] h-12 w-full mt-1 p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='text' placeholder='결제 금액' value={totalPrice} onChange={(e)=>setTotalPrice(e.target.value)} />
            </div>
          </div>

          <div className='flex flex-col gap-2 w-full'>
            <div className='flex justify-between'>
              <p className=''>주문 제품 및 메모</p>
              <button className='px-2 text-yellow-400' onClick={()=>alert('텍스트박스 우측 하단을 드래그시 창을 늘리거나 축소 할 수 있습니다.')}>
                펼치기
              </button>
            </div>
            <div className='flex flex-col justify-center items-center'>
              <textarea className='bg-[#2E2E2E] text-center rounded-md w-full h-[70px] border-[1px] outline-none border-gray-300 ml-5 mr-5 p-3' type='text' placeholder='구매하신 제품 및 메모' value={deliveryMemo} onChange={(e)=>setDeliveryMemo(e.target.value)}/>
            </div>
          </div>
          
          {/* 처리 날짜 검색 */}
          <div className='w-full flex flex-col gap-2'>
            <p>처리 날짜</p>
            <input id='searchInput' disabled className='bg-[#2E2E2E] h-12 w-full p-2 rounded-md text-center outline-none' type='text' placeholder='〈 고객을 선택하세요 〉' value={deliveryDate} onChange={(e)=>setDeliveryDate(e.target.value)}/>
          </div>  

          {/* 언더라인 */}
          <div className='border-b-[1px] border-gray-400 py-1'></div>
            
          {/* 처리 버튼 */}
          <div className='flex flex-col gap-2 pt-2'>
            <div>
              <button className='bg-[#2E2E2E] h-[40px] w-[100%] rounded-md text-center border-[1px] border-[#1F8BE2]' onClick={btnDeliveryAdd}>
                택배 / 퀵 등록
              </button>
            </div>
            <div className='grid grid-cols-2 gap-2'>
              <button className='bg-[#2E2E2E] h-[40px] rounded-md text-center border-[1px] border-yellow-300' onClick={btnDeliveryUpdate}>
                수정
              </button>
              <button className='bg-[#2E2E2E] h-[40px] rounded-md text-center border-[1px] border-yellow-300' onClick={btnDeliveryDelete}>
                삭제
              </button>
            </div>
          </div>

        </div>
      </div>

    </div>
  )
}

export default Delivery